import React, { Component } from 'react';

class About extends Component {
    render() {
        return (
            <div className="col-10 p-3 my-3 mx-auto about" id="about">
                <h4 className='title'>About George:</h4>
                <p className='lead'>George is a self-driven,focused and a goal-oriented software developer.  Am currently on my final year at Kenyatta University
                pursuing <code>Bsc. Mathematics and Computer Science (Statistics)</code>. 
                </p>
                <hr/>
                <h5 className="text-muted">Experience</h5>
                <div>
                    <p className='text-warning'>Oct 2020 - Jan 2021</p>
                    <p><code>Role: </code>Backend Developer Intern</p>
                    <p className="lead"><code>Company: </code> Touch Inspiration</p>
                    <p className="lead"><code>Description: </code>I have been working as a backend developer intern for the last 4 months. I was working with backend technologies such as Node js(Loopback js) and Mongodb.</p>
                </div>
            </div>
        );
    }
}

export default About;